import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { ServiceDef } from 'src/app/models/service-def';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { DwUtils } from "../../../../components/utils/dw-utils";
import { MatTableDataSource } from "@angular/material/table";
import { Settings } from "../../../../services/settings";
import { ServiceRequestType } from "../../../../models/service-request-type";
import { NewRequest } from "../../../../models/newrequest";
import { ValidationResult } from "../../../../models/validation-result";
import { Case } from "../../../../models/case";
import { ServiceRequest } from "../../../../models/service.request";
import { ServiceDefService } from "../../../../services/servicedef.service";
import { ExistingMembersComponent } from "./existing-members/existing-members.component";
import { HouseholdMember } from "../../../../models/household-member";
import { CaseMember } from "../../../../models/case-member";
import { NewMessageHelper } from 'src/app/options/requests/drawer/mailmessages/newmessage/newmessage-helper';
import { MessageDefinitionService } from 'src/app/services/messages.service';

class ServiceTypeStruct {

	select: boolean;
	id: number;
	description: string;
	amount: number;
	unitOfMeasure: string;
	baseDurationDays: number;

	constructor(select: boolean, id: number, desc: string, amount: number, uom: string, baseDays: number) {
		this.select = select;
		this.id = id;
		this.description = desc;
		this.amount = 0;
		this.unitOfMeasure = uom;
		this.baseDurationDays = baseDays;
	}
}

@Component({
	selector: 'app-add-new-case',
	templateUrl: './add-new-case.component.html',
	styleUrls: ['./add-new-case.component.css']
})
export class AddNewCaseComponent {

	public strErr: string | null = '';
	public id: number;
	public caseNumber: any | null = '';

	/** address / contact **/
	public address1: any | null = '';
	public address2: any | null = '';
	public city: any | null = '';
	public state: any | null = '';
	public zipCode: any | null = '';
	public county: any | null = '';
	public phoneNumber: any | null = '';
	public emailAddress: any | null = '';

	/** primary applicant **/
	public firstName: any | null = '';
	public middleName: any | null = '';
	public lastName: any | null = '';
	public dob: any | null = '';
	public gender: any | null = '';
	public duplicateFlag: string = '';
	public isUniqueMember: boolean = null;
	public applicantMember: HouseholdMember;

	/** advocate info **/
	public advocateFirstName: string;
	public advocateMiddleName: string;
	public advocateLastName: string;
	public advocateEmail = '';
	public advocatePhone: string = '';
	public useAdvocate: boolean = false;
	public advocateMember: HouseholdMember;

	/** members list **/
	public membersList: any;
	public showExistingMembersDlg: boolean = false;
	public showAddNewCaseMsgDlg: boolean = false;

	/** Other items **/
	public currentNeed: any | null = '';
	public matchAttempt: boolean;
	public dataSource: MatTableDataSource<any>;
	public Idx: number = -1;
	public displayedColumns = ['id', 'description', 'amount', 'unitOfMeasure', 'select'];
	public records: any;
	public servicesRequested: any;
	public updateRecord: NewRequest;
	public agencyId: number;
	public serviceDefList: any;
	public selectedRecord: any;
	public countyList: any;
	public submitEnabled: boolean = false;

	public msgHelper: NewMessageHelper;
	public createdRec: Case;

	@Output() submitClickedEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() cancelClickedEvent: EventEmitter<any> = new EventEmitter();

	@ViewChild('existingmembers', { static: true }) 'existingmembers': ExistingMembersComponent;

	constructor(private serviceRequestsService: ServiceRequestsService,
		public serviceDefService: ServiceDefService, public messageService: MessageDefinitionService) {

	}

	@HostListener('document:keydown', ['$event'])
	onKeydownHandler(event: KeyboardEvent) {
		this.strErr = '';
	}

	public ngOnInit() {
		if (Settings.getInstance().regionsList === undefined) {
			this.loadRegionsList();
		}
	}

	public onShowHandler() {
		this.id = 0;
		this.strErr = '';
		this.Idx = -1;
		this.matchAttempt = true;
		this.agencyId = Settings.getInstance().loggedInUser.agencyId;
		this.countyList = Settings.getInstance().getCountyDataSource(false);
		this.caseNumber = '';
		this.currentNeed = '';
		this.submitEnabled = true;
		this.showAddNewCaseMsgDlg = true;
	}
	public initializeRecords(): void {
		this.initializeApplicantRecord();
		this.initializeAdvocateRecord();
		this.initializeCaseRecord(new Case());
		this.queryServiceTypes();
		this.generateCaseNumberHandler();
	}
	/** load information **/
	public loadRegionsList() {
		this.serviceDefService.getAllRegions().subscribe(
			(result) => {
				Settings.getInstance().regionsList = result;
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve region data from the service');
			}
		)
	}
	public queryServiceTypes(): void {

		this.records = new Array();

		this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
			(results) => {
				for (const rec of results) {
					if (rec.activeStatus !== 'Active') {
						continue;
					}
					let struct = new ServiceTypeStruct(
						false,
						rec.id,
						rec.description,
						0,
						rec.unitOfMeasure,
						rec.baseDurationDays);
					this.records.push(struct);
				}
				// Sort the records alphabetically by description
				this.records.sort((a, b) => a.description.localeCompare(b.description));
				this.dataSource = new MatTableDataSource(this.records);
				this.queryServiceDefs();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching service request types');
			});
	}
	public queryServiceDefs(): void {
		this.serviceDefService.getAllServiceDefsForMatch(this.agencyId).subscribe(
			(result) => {
				this.serviceDefList = result;
			},
			(error) => {
				Settings.getInstance().handleError(error, "Fetching Service Defs")
			});
	}
	/*** initialize records ***/
	public initializeCaseRecord(c: Case): void {
		this.id = c.id;
		this.firstName = c.firstName;
		this.lastName = c.lastName;
		this.address1 = c.address1;
		this.address2 = c.address2;
		this.city = c.city;
		this.state = c.state;
		this.zipCode = c.zipCode;
		this.county = c.county;
		this.dob = c.dateOfBirth;
		this.phoneNumber = c.phoneNumber;
		this.emailAddress = c.email;

	}
	public initializeApplicantRecord(): void {
		this.applicantMember = new HouseholdMember();
		this.firstName = this.applicantMember.firstName;
		this.middleName = this.applicantMember.middleName;
		this.lastName = this.applicantMember.lastName;
		this.dob = this.applicantMember.dateOfBirth;
		this.gender = this.applicantMember.gender;
		this.isUniqueMember = null;
	}
	public initializeAdvocateRecord(): void {
		this.useAdvocate = false;
		this.advocateMember = new HouseholdMember();
		this.advocateFirstName = this.advocateMember.firstName;
		this.advocateMiddleName = this.advocateMember.middleName;
		this.advocateLastName = this.advocateMember.lastName;
		this.advocateEmail = '';
		this.advocatePhone = '';
	}
	/** form events **/
	public setRecord(): void {

		/** cases **/
		this.updateRecord = new NewRequest();
		this.updateRecord.caseNumber = this.caseNumber.toUpperCase();
		this.updateRecord.firstName = DwUtils.capitalize(this.firstName);
		this.updateRecord.lastName = DwUtils.capitalize(this.lastName);
		this.updateRecord.address1 = DwUtils.capitalize(this.address1);
		this.updateRecord.address2 = DwUtils.capitalize(this.address2);
		this.updateRecord.city = DwUtils.capitalize(this.city);
		this.updateRecord.state = this.state.toUpperCase();
		this.updateRecord.zipCode = this.zipCode;
		this.updateRecord.county = DwUtils.capitalize(this.county);
		this.updateRecord.dob = this.dob;
		this.updateRecord.phoneNumber = this.phoneNumber;
		this.updateRecord.emailAddress = this.emailAddress;
		this.updateRecord.currentNeed = this.currentNeed;

		/** Advocate ***/
		if (this.useAdvocate === true) {
			this.advocateMember.setAdvocateRecord(this.advocateFirstName,
				this.advocateMiddleName, this.advocateLastName);
			this.advocateMember['relationship'] = 'Advocate';
		}
		/** Service Requests **/
		this.servicesRequested = new Array();
		this.servicesRequested = this.dataSource.data.filter(s => s.select === true);

	}
	public onRowClicked(row): void {
		this.selectedRecord = row;
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
		DwUtils.highlightFocus('idAmount');
	}
	public tableKeyDown(event: any): void {
		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];

			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];

			}
		}
	}
	public doChangeAmount(event, idx: number): void {

		if (this.selectedRecord.amount > 0) {
			this.dataSource.data[idx].select = true;
		}
		else {
			this.dataSource.data[idx].select = false;
		}
	}
	/** Applicant Selection methods **/
	public doDuplicateCheck(withContinue: boolean = false) {

		/** do we have what we need for a valid applicant? **/
		if (!this.validApplicant()) {
			this.submitEnabled = true;
			return;
		}

		this.membersList = [];
		this.isUniqueMember = null;
		this.firstName = DwUtils.capitalize(this.firstName);
		this.lastName = DwUtils.capitalize(this.lastName);

		this.duplicateFlag = DwUtils.createDuplicateKey(this.firstName, this.lastName, this.dob, this.gender);

		if (this.duplicateFlag.length > 0) {

			this.serviceRequestsService.getMembersByDuplicateKey(this.duplicateFlag).subscribe(
				(result) => {

					if (result.length > 0) {
						this.isUniqueMember = false;
						this.membersList = result;

						this.showMembersForSelection();
					}
					else {
						this.isUniqueMember = true;
						this.setApplicantMember();

						if (withContinue === true) {
							this.continueSubmit();
						}
					}
				},
				(error) => {
					Settings.getInstance().handleError(error, "fetching duplicate members");
					return error;
				});
		}
	}
	public validApplicant(): boolean {

		this.strErr = '';
		if (this.firstName.length === 0) {
			this.strErr = 'Error: a first name is required';
			DwUtils.setFocus('firstNameId');
			return false;
		}
		if (this.lastName.length === 0) {
			this.strErr = 'Error: a last name is required';
			DwUtils.setFocus('lastName');
			return false;
		}

		if (this.dob === null) {
			this.strErr = 'Error: a date of birth is required';
			DwUtils.setFocus('dobId');
			return false;
		}
		if (!DwUtils.chkValidDate(this.dob)) {
			this.strErr = 'Error: Invalid date - format is YYYY-MM-DD';
			DwUtils.setFocus('dobId');
			return false;
		}
		if (this.gender.length === 0) {
			this.strErr = 'Error: a gender is required';
			DwUtils.setFocus('genderId')
			return false;
		}
		return true;
	}
	public doDOBFocusOut(event: any): void {

		/** check to see if the date
		 *
		 */
		this.strErr = '';
		const localErrStr = DwUtils.chkDateOfBirth(this.dob, 16);
		if (localErrStr.length > 0) {
			this.strErr = localErrStr;
		}
		else {
			this.strErr = '';
		}
	}
	public showMembersForSelection(): void {
		this.showExistingMembersDlg = true;
		this.existingmembers.membersList = this.membersList;
		this.existingmembers.onshowHandler();
	}
	public doMemberSelected(member: any): void {
		this.showExistingMembersDlg = false;
		this.submitEnabled = true;
		this.isUniqueMember = true;
		this.setApplicantMember(member);
	}
	public doCancelMemberSelected(): void {
		/** if the user cancelled out then we are going to assume
		 * that this will be a unique member **/
		this.showExistingMembersDlg = false;
		this.submitEnabled = true;
		this.isUniqueMember = true;
		this.setApplicantMember();
	}
	public setApplicantMember(memberRec: any = null): void {

		if (memberRec === null) {
			this.applicantMember.setApplicantRecord(this.firstName, this.middleName, this.lastName, this.dob, this.gender);
		}
		else {
			/** use the applicant member record selected **/

			this.firstName = DwUtils.capitalize(memberRec.firstName);
			this.middleName = DwUtils.capitalize(memberRec.middleName);
			this.lastName = DwUtils.capitalize(memberRec.lastName);
			this.dob = memberRec.dateOfBirth;
			this.gender = memberRec.gender;
			this.applicantMember = memberRec;
		}

		this.applicantMember['relationship'] = 'Self';
	}
	/** Advocate Selection **/
	public generateCaseNumberHandler() {
		this.caseNumber = DwUtils.genAlphaNumericKey();

		setTimeout(() => {
			DwUtils.setFocus('firstNameId');
		}, 100);
	}
	public doAdvocateChange(event: any): void {

		/** clear the fields if the checkbox is unchecked **/
		if (event.checked === false) {
			this.advocatePhone = '';
			this.advocateEmail = '';
			this.advocateLastName = '';
			this.advocateFirstName = '';
			this.advocateMiddleName = '';
		}
	}
	public submitRecord() {

		this.submitEnabled = false;
		this.strErr = '';

		if (this.isUniqueMember === null) {
			this.doDuplicateCheck(true);
		} else {
			this.continueSubmit();
		}
	}
	public continueSubmit(): void {

		this.setRecord();

		let vr = new ValidationResult();
		vr = this.updateRecord.validateRecord();

		if (this.useAdvocate === true) {
			if (this.advocateFirstName.length === 0) {
				this.strErr = 'Error: The advocate\'s first name is required';
				DwUtils.setFocus('advocateFirstNameId');
				this.submitEnabled = true;
				return;
			}
			if (this.advocateLastName.length === 0) {
				this.strErr = 'Error: The advocate\'s last name is required';
				DwUtils.setFocus('advocatelastName');
				this.submitEnabled = true;
				return;
			}
			if ((this.advocateEmail.length === 0) && (this.advocatePhone.length === 0)) {
				this.strErr = 'Error: Either email or a phone number must be specified'
				DwUtils.setFocus('advocatePhoneNumber');
				this.submitEnabled = true;
				return;
			}
		}
		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.highlightFocus(vr.focus_field);
			this.submitEnabled = true;
			return;
		}

		if (this.servicesRequested.length === 0) {
			this.strErr = 'Error: no service(s) have been selected';
			this.submitEnabled = true;
			return;
		}

		/*** create the new case ***/
		let caseRec = new Case();
		caseRec.setCaseForNewRequest(this.updateRecord);
		caseRec.advocateEmail = this.advocateEmail;
		caseRec.advocatePhoneNumber = this.advocatePhone;

		this.serviceRequestsService.createCase(caseRec).subscribe(
			(result) => {
				this.id = result.id;
				caseRec.id = result.id;
				this.createdRec = caseRec;
				this.createServiceRequests();
				return;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Creating a case');
				this.submitEnabled = true;
			});
	}
	public createServiceRequests(): void {

		/** the first step is to loop through the existing services chosen
		 * and set up service request records for each ...
		 */
		let serviceRequests = new Array();
		for (let rec of this.servicesRequested) {

			let sr: ServiceRequest = new ServiceRequest();
			sr.serviceRequestTypeId = rec.id;
			sr.amountRequested = rec.amount;
			sr.totalAmountProvided = 0;
			sr.unitOfMeasure = rec.unitOfMeasure;
			sr.caseId = this.id;
			sr.currentNeed = this.currentNeed;
			sr.dueDate = DwUtils.getDueDate(new Date(), rec.baseDurationDays);
			sr.requestStatusId = 1;			/** unmatched **/
			sr.dateQualifier = '';
			sr.serviceDefId = 0;
			sr.agencyId = 0;
			sr.startDate = null;
			sr.endDate = null;

			/** if we want to attempt to match this request
			 * with services that the agency supplies then
			 * we will attempt to locate the serviceDefId
			 */
			if (this.matchAttempt === true) {
				let serviceDefId = this.locateServiceDefId(this.agencyId, rec.id);

				if (serviceDefId > 0) {
					sr.serviceDefId = serviceDefId;				/** service def Id **/
					sr.agencyId = this.agencyId;				/** current agencyId **/
					sr.requestStatusId = 2;						/** matched **/
				}
			}
			serviceRequests.push(sr);
		}
		/** insert the service requests (pass as an array of structs) ***/

		this.serviceRequestsService.createMultipleRequests(serviceRequests).subscribe(
			(results) => {
				this.createMembers();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Inserting new service requests');
				this.submitEnabled = true;
			});
	}
	public createMembers(): void {

		/** case id is in this.id **/
		this.applicantMember.caseId = this.id;
		if (this.applicantMember.id === 0) {
			/** create casemember record **/
			this.serviceRequestsService.createHouseholdMember(this.applicantMember).subscribe(
				(result) => {
					this.applicantMember.id = result.id;
					if (this.useAdvocate === true) {
						this.createAdvocateMember();
					}
					else {
						this.submitClickedEvent.emit();
					}
				},
				(error) => {
					Settings.getInstance().handleError(error, 'creating a case member record.')
					this.submitEnabled = true;
				});
		}
		else {
			// create member record (with the case id).
			const cm = new CaseMember();
			cm.caseId = this.id;
			cm.memberId = this.applicantMember.id;
			cm.relationship = 'Self';
			cm.primaryApplicantFlag = 1;

			this.serviceRequestsService.createSimpleCaseMemberRecord(cm).subscribe(
				(result2) => {

					if (this.useAdvocate === true) {
						this.createAdvocateMember();
					}
					else {
						this.submitClickedEvent.emit();
					}
				},
				(error) => {
					Settings.getInstance().handleError(error, 'creating a simple case member record.');
					this.submitEnabled = true;
				});
		}
	}
	public createAdvocateMember(): void {

		this.advocateMember.caseId = this.id;
		this.serviceRequestsService.createHouseholdMember(this.advocateMember).subscribe(
			(result) => {
				this.advocateMember.id = result.id;
				this.submitClickedEvent.emit();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'creating an advocate member record.')
			});

	}
	public locateServiceDefId(agId, requestTypeId: number): number {

		let serviceDefId = 0;
		/** any services defined for my agency?? **/
		if (this.serviceDefList.length === 0) {
			return 0;
		}

		/** get the serviceDefId for the agency **/
		let sd = this.serviceDefList.find(s => s.serviceRequestTypeId === requestTypeId && s.zipCode === this.zipCode);
		if (sd === undefined) {
			serviceDefId = 0;
		}
		else {
			serviceDefId = sd.sId;
		}
		return serviceDefId;
	}
	public cancelSubmitRecord() {
		this.cancelClickedEvent.emit();
	}
	/** Add New Case Message **/

	public acceptAddNewRecord(): void {
		this.showAddNewCaseMsgDlg = false;
		this.initializeRecords();
	}
	public cancelAddNewRecord(): void {
		this.showAddNewCaseMsgDlg = false;
		this.cancelClickedEvent.emit();
	}
}
